import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import styles from './modal.module.css';

// Components
import SubmitButton from '../submit-button/submit-button';

// Providers
import {
  initialModalContent,
  GeneralContext,
} from '../../providers/general-provider';
import { useLocation } from 'react-router-dom';

const Modal: FC<{ content: ModalContent }> = ({ content }) => {
  const location = useLocation();
  const { setModalContent } = useContext(GeneralContext);
  const [error, setError] = useState<string | null>(null);

  const previousPathnameRef = useRef(location.pathname);
  useEffect(() => {
    if (previousPathnameRef.current !== location.pathname) {
      setModalContent(initialModalContent);
      previousPathnameRef.current = location.pathname;
    }
  }, [location.pathname, setModalContent]);

  const resetModal = () => {
    setModalContent(initialModalContent);
    setError(null);
  };

  const onCloseModal = (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    evt.preventDefault();

    if (content.onCloseModal) {
      content
        .onCloseModal(content.submitData)
        .then(() => resetModal())
        .catch((err) => setError(err));
    } else {
      setModalContent(initialModalContent);
      setError(null);
    }
  };

  const onSubmitModal = (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    evt.preventDefault();

    content
      .onSubmitButtonClick(content.submitData)
      .then(() => resetModal())
      .catch((err) => setError(err));
  };

  if (!content.isOpen) return null;

  return (
    <div className={styles.modalContainer}>
      <div className={styles.modalContentBox}>
        <div className={styles.modalHeader}>
          <p className={styles.modalTitle}>{content.title}</p>
          <div className={styles.modalClose} onClick={onCloseModal}></div>
        </div>
        <div className={styles.modalContent}>{content.modalContent}</div>
        {error && (
          <div className={styles.error}>
            <p>{error}</p>
          </div>
        )}
        {content.submitButtonTitle && 
        <div className={styles.modalFooter}>
          <SubmitButton
            value={content.submitButtonTitle}
            variant={content.submitButtonType}
            onClick={onSubmitModal}
            disabled={content.submitButtonDisabled}
          />
        </div>
        }
      </div>
    </div>
  );
};

export default Modal;
